import PropTypes from "prop-types"
import { FormattedMessage } from "react-intl"
import TitleUnderlined from "components/TitleUnderlined"
import { H2_TAG } from "components/TitleUnderlined/constants"
import { ITEMS } from "./constants"
import ApplicationsGeneric from "components/Applications"

const Applications = ({ id }) => (
  <div id={id}>
    <div className="container my-2 py-4">
      <div className="row">
        <div className="col-12">
          <TitleUnderlined hTag={H2_TAG}>
            <FormattedMessage
              id="Pranna.Applications.title"
              description="Pranna section title applications"
              defaultMessage="Uso y aplicaciones"
            />
          </TitleUnderlined>
          <ApplicationsGeneric items={ITEMS} />
        </div>
      </div>
    </div>
  </div>
)

Applications.propTypes = {
  id: PropTypes.string.isRequired
}

export default Applications
